import * as React from 'react';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import MailListViewSecondaryHeader from './MailListViewSecondaryHeader';
import MailSearchFilter from '../components/MailSearchFilter';
import { observer } from 'mobx-react';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import { TableView } from 'mini-mail-prefetch';

const styles = require('./MailListHeader.scss');

@observer
export default class MailListHeader extends React.Component<any, {}> {
    render() {
        const isSearchView = listViewStore.shouldShowSearchBox;
        const selectedTableView: TableView = getSelectedTableView();
        return isSearchView ? (
            selectedTableView?.tableQuery.type === TableQueryType.Search && (
                <div className={styles.searchFilter}>
                    <MailSearchFilter />
                </div>
            )
        ) : (
            <MailListViewSecondaryHeader forwardedRefs={this.props.forwardedRefs} />
        );
    }
}
